module.exports = __webpack_public_path__ + "static/media/active.f7f7329a.svg";